var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgEmpty = function SvgEmpty(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 126 129"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#F1F3F4",
    stroke: "#DEE2E6",
    strokeMiterlimit: 10,
    strokeWidth: 2.425,
    d: "M63 126.913c33.948 0 61.469-27.522 61.469-61.59 0-34.07-27.643-61.591-61.469-61.591-33.948 0-61.47 27.522-61.47 61.59 0 34.07 27.522 61.591 61.47 61.591Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#DEE2E6",
    strokeMiterlimit: 10,
    strokeWidth: 2.425,
    d: "M121.573 32.972v71.335c0 2.093-1.744 3.837-3.837 3.837H9.338c-2.093.087-3.837-1.657-3.837-3.75V32.971a3.815 3.815 0 0 1 3.837-3.837h108.398a3.815 3.815 0 0 1 3.837 3.837Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#DEE2E6",
    d: "M121.459 5.698c-.632 2.308-3.163 3.147-5.693 1.678-2.742-1.259-4.64-2.308-4.218-4.406.633-2.099 3.163-2.308 6.116-2.518 3.584-.42 4.217 2.937 3.795 5.246M101.004 7.796c1.054 1.888 4.006 3.147 6.115 1.259 2.32-2.099 4.217-3.567 3.163-5.666-1.054-1.888-2.741-1.259-6.326-.84-2.952.63-4.218 3.148-2.952 5.247"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#A9B3BD",
    d: "M110.282.032c1.476-.21 2.952.63 3.374 1.889.211.42.422 1.049.422 1.469.422 2.937-.633 5.455-2.32 5.665-1.898.42-3.795-1.679-4.006-4.406V2.76c.211-1.469 1.054-2.518 2.53-2.728.211 0 0 0 0 0"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#DEE2E6",
    strokeMiterlimit: 10,
    strokeWidth: 2.425,
    d: "M121.573 32.972v5.494H5.501V32.97a3.815 3.815 0 0 1 3.837-3.837h108.398a3.815 3.815 0 0 1 3.837 3.837Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#A9B3BD",
    d: "M10.646 35.413a1.308 1.308 0 1 0 0-2.616 1.308 1.308 0 0 0 0 2.616M14.745 35.413a1.308 1.308 0 1 0 0-2.616 1.308 1.308 0 0 0 0 2.616M18.93 35.413a1.308 1.308 0 1 0 0-2.616 1.308 1.308 0 0 0 0 2.616"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    stroke: "#A9B3BD",
    strokeDasharray: "4.85 4.85",
    strokeMiterlimit: 10,
    strokeWidth: 2.425,
    d: "M111.753 12.13c2.088 22.79 3.132 28.008-1.595 48.646-1.537 4.589-3.074 9.614-6.367 13.11-4.611 5.462-12.955 7.865-19.762 6.118-7.026-1.748-12.735-7.866-14.052-15.295-1.098-4.588.439-10.05 4.391-12.89 4.172-2.623 10.1-1.967 13.614 1.31 3.952 3.278 5.489 8.303 5.27 13.11-.22 4.807-1.977 9.613-4.392 13.765-5.46 10.207-7.708 10.17-18.883 26.934"
  })));
};
export default SvgEmpty;